// extracted by mini-css-extract-plugin
export default {"StaticDiffPreview":"StaticUnifiedDiffPreview-module__StaticDiffPreview--otVuG","HeaderContainer":"StaticUnifiedDiffPreview-module__HeaderContainer--tQoY0"};